import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from "../lib/cn.js";
const graphemes = new Intl.Segmenter(undefined, { granularity: "grapheme" });
/** The first letter of up to two words of a name ("Rahim Uddin" → "RU"); Bengali conjuncts stay whole. */
export function initialsOf(name) {
    return name
        .trim()
        .split(/\s+/)
        .filter((word) => word !== "")
        .slice(0, 2)
        .map((word) => graphemes.segment(word)[Symbol.iterator]().next().value?.segment ?? "")
        .join("")
        .toUpperCase();
}
/** A person's initials in a tinted circle (no photos yet). */
export function Avatar({ name, size = "md", className, ...props }) {
    return (_jsx("span", { "aria-hidden": true, className: cn("inline-flex shrink-0 select-none items-center justify-center rounded-full bg-primary-soft font-semibold text-primary", size === "sm" ? "size-7 text-[11px]" : size === "lg" ? "size-12 text-base" : "size-9 text-xs", className), ...props, children: initialsOf(name) }));
}
//# sourceMappingURL=avatar.js.map